import React from 'react';
import classNames from 'classnames';
import { components } from 'react-select';

const Control = (props) => {
  const {
    selectProps: { invalid, isTouchDevice },
  } = props;
  const { children, ...restProps } = props;
  const classes = classNames({
    'ws-ui-tag-input__control--is-invalid': invalid,
    'ws-ui-tag-input__control--is-touch-device': isTouchDevice,
  });

  return (
    // @ts-ignore TS(2740): Type '{ children: ReactNode; className: string; se... Remove this comment to see the full error message
    <components.Control {...restProps} className={classes}>
      {children}
    </components.Control>
  );
};

export default Control;
